import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cl{background:var(--shades-white);}.ssr-plugin'
import '.cg{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b0{max-width:77.5rem;}.ssr-plugin'
import '.cm{justify-content:stretch;}.ssr-plugin'
import '.cn{position:sticky;}.ssr-plugin'
import '.co{top:0px;}.ssr-plugin'
import '.cp{z-index:10;}.ssr-plugin'
import '.cq{padding-block:1rem;}.ssr-plugin'
import '.cr{height:3rem;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.cs{flex-wrap:wrap;}.ssr-plugin'
import '.ct{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ay{margin-top:2rem;}.ssr-plugin'
import '.cu{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab g b cl"
      >
        <div className="cg a c g b"
        >
          <div className="b0 a b cm cn co cp cl"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cq cr a a0 c cs"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="ct a b ab ay cu b0"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
